import { React, useState } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap,
  TableLayoutData,
  PipeDesign,
} from "../../styledElements";
import { Button, PageHeader, Tabs, Row, Col, Table, Tooltip } from "antd";
import { Styled } from "../../pageStyled";
import Iconmoon from "../../../Components/IconsFiles/icon";
import RejectJobCardData from "../approveDeckleDrawer/approveRejectCardDrawer";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
const Panes = Tabs.TabPane;

const dataBody = [
  {
    key: "1",
    pono: "1675",
    orderno: "1078",
    createddate: "02 Dec 2021",
    customercode: "12141",
    type: "Sheet",
    size: "100x165 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
    priority: "high",
  },
  {
    key: "2",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
    priority: "high",
  },
  {
    key: "3",
    pono: "165",
    orderno: "1118",
    createddate: "08 Dec 2021",
    customercode: "1231",
    type: "Reel",
    size: "76x65 CM",
    quantity: "40 Reels",
    weight: "140 Tonnes",
  },
  {
    key: "4",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
  },
  {
    key: "5",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
  },
  {
    key: "6",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
  },
  {
    key: "7",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
  },
  {
    key: "8",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
  },
  {
    key: "9",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
  },
  {
    key: "10",
    pono: "161",
    orderno: "1018",
    createddate: "02 Dec 2021",
    customercode: "1211",
    type: "Reel",
    size: "100x65 CM",
    quantity: "50 Reels",
    weight: "210 Tonnes",
  },
];

function onChange(pagination, filters, sorter, extra) {
  console.log("params", pagination, filters, sorter, extra);
}

const ApproveDeckleJobCardDetailData = (props) => {
  const [approveJobCardsDetails, setApproveJobCardsDetails] = useState(false);
  const [isApproveVisibleModal, setIsApproveVisibleModal] = useState(false);

  const columnsHead = [
    {
      title: "Po.No",
      dataIndex: "pono",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    {
      title: "Order No",
      dataIndex: "orderno",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Cust. Code",
      dataIndex: "customercode",
      width: "8%",
    },
    {
      title: "Del Date",
      dataIndex: "createddate",
      width: "9%",
    },
    {
      title: "Qty Matched",
      dataIndex: "quantity",
      width: "8%",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      width: "9%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "5%",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "7%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={"We need to display every  order remark here"}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },
    {
      title: "Actions",
      dataIndex: "action",
      width: "7%",
      render: () => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const showApproveJobCardDetails = () => {
    setApproveJobCardsDetails(true);
  };
  const onCloseFullJobCardDrawer = () => {
    setApproveJobCardsDetails(false);
  };
  const onCloseViewJobCardDrawer = () => {
    setApproveJobCardsDetails(false);
  };

  const modalShow = () => {
    setIsApproveVisibleModal(true);
  };

  const modalClose = () => {
    setIsApproveVisibleModal(false);
  };

  const modalConfirm = () => {
    setIsApproveVisibleModal(false);
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp>
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Job Card Details"
          extra={[
            <Button
              key="2"
              className="themeBtn noBg"
              onClick={showApproveJobCardDetails}
            >
              <Iconmoon icon="wrong-file" size={14} color="#EA655B" />
              Reject
            </Button>,
            <Button key="1" className="themeBtn" onClick={modalShow}>
              <Iconmoon icon="correct-file" size={14} color="#ffffff" />
              Approve Job Card
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <ResultWrap>
        <DetailFields className="jobCardView">
          <PageTitleComp style={{ borderBottom: "0" }}>
            <PageHeader ghost={false} title="Job Card 597"></PageHeader>
          </PageTitleComp>
          <div className="MatchResult">
            <Row span={24}>
              <Col
                span={13}
                className="pipeBlock"
                style={{ paddingRight: "20px" }}
              >
                <PipeDesign>
                  <div class="ant-pipe-container">
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "180px", left: "0px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "100px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "130px", left: "-46px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "80px", left: "-69px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-white"
                        style={{ width: "50px", left: "-92px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child-end">
                      Trim Loss: 5%
                      <p>Del: 10/12/2021</p>
                    </div>
                  </div>

                  <div class="ant-pipe-container">
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "180px", left: "0px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "180px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "110px", left: "-46px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-white"
                        style={{ width: "50px", left: "-69px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child-end">
                      Trim Loss: 2.7%
                      <p>Del: 14/12/2021</p>
                    </div>
                  </div>

                  <div class="ant-pipe-container">
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "180px", left: "0px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "80px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "130px", left: "-46px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "70px", left: "-69px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-white"
                        style={{ width: "80px", left: "-92px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child-end">
                      Trim Loss: 4.2%
                      <p>Del: 07/12/2021</p>
                    </div>
                  </div>

                  <div class="ant-pipe-container">
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "80px", left: "0px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "230px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "160px", left: "-46px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-white"
                        style={{ width: "50px", left: "-69px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child-end">
                      Trim Loss: 2.7%
                      <p>Del: 14/12/2021</p>
                    </div>
                  </div>

                  <div class="ant-pipe-container">
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "180px", left: "0px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "80px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "130px", left: "-46px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "100px", left: "-69px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-white"
                        style={{ width: "50px", left: "-92px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child-end">
                      Trim Loss: 4.2%
                      <p>Del: 07/12/2021</p>
                    </div>
                  </div>

                  <div class="ant-pipe-container">
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "180px", left: "0px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "180px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "110px", left: "-46px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-white"
                        style={{ width: "50px", left: "-69px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child-end">
                      Trim Loss: 2.7%
                      <p>Del: 14/12/2021</p>
                    </div>
                  </div>

                  <div class="ant-pipe-container">
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "180px", left: "0px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "80px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-dark"
                        style={{ width: "130px", left: "-46px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-light"
                        style={{ width: "100px", left: "-69px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child">
                      <div
                        class="ant-cylinder-white"
                        style={{ width: "50px", left: "-92px" }}
                      ></div>
                    </div>
                    <div class="ant-roll-child-end">
                      Trim Loss: 4.2%
                      <p>Del: 07/12/2021</p>
                    </div>
                  </div>
                </PipeDesign>
              </Col>
              <Col span={11} className="colLayoutBlock leftPostTab">
                <Tabs defaultActiveKey="1" className="topPostTab innerPostTab">
                  <Panes tab="Solution 1 summary" key="1">
                    <div className="lossValue">
                      <Row span={24}>
                        <Col span={12}>
                          <div className="summaryValue">
                            <h5>
                              <span className="trimCut"></span> Trim Loss
                            </h5>
                            <span>1.37%</span>
                            {/* <label><img src={downgrade} alt="Trim Loss" /> 1.3% lesser than solution 2</label> */}
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="summaryValue">
                            <h5>
                              <span className="trimBox"></span> Fulfilment
                            </h5>
                            <span>89%</span>
                            {/* <label><img src={upgrade} alt="Fulfilment" /> 3.6% greater than solution 2</label> */}
                          </div>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={12}>
                          <ul>
                            <li>
                              <span>Paper Machine</span>
                              <p>PM2</p>
                            </li>
                            <li>
                              <span>Product Specifications</span>
                              <p>Kraft/128/24/Copier</p>
                            </li>
                            <li>
                              <span>Number of Fulfilled Reels</span>
                              <p>27</p>
                            </li>
                            <li>
                              <span>Number of Parent Reels</span>
                              <p>7</p>
                            </li>
                          </ul>
                        </Col>
                        <Col span={12}>
                          <ul>
                            <li>
                              <span>Deckle Width</span>
                              <p>300 CM</p>
                            </li>
                            <li>
                              <span>Core ID / Reel OD</span>
                              <p>18 CM / 100 CM</p>
                            </li>
                            <li>
                              <span>Number of Priority Reels</span>
                              <p>2</p>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </Panes>
                  <Panes tab="Fulfilled orders" key="2">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat removePagnation"
                        style={{ marginTop: "25px" }}
                      >
                        <Table
                          columns={columnsHead}
                          dataSource={dataBody}
                          onChange={onChange}
                          scroll={{ x: 1080 }}
                          rowClassName={(record) => record.priority}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Unfulfilled" key="3">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat removePagnation"
                        style={{ marginTop: "25px" }}
                      >
                        <Table
                          columns={columnsHead}
                          dataSource={dataBody}
                          onChange={onChange}
                          scroll={{ x: 1080 }}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                </Tabs>
              </Col>
            </Row>
          </div>
        </DetailFields>
      </ResultWrap>
      <ModalPopup visible={isApproveVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Are you sure?</span>
          <p>
            You are about to approve this job card, once approved this job card
            can’t be altered later
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
      <RejectJobCardData
        visible={approveJobCardsDetails}
        onClose={onCloseViewJobCardDrawer}
        onCloseGrade={onCloseFullJobCardDrawer}
      ></RejectJobCardData>
    </RightLayoutContainer>
  );
};
export default ApproveDeckleJobCardDetailData;
